React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ renderComponent } = require 'app/src/components/ComponentWrapper'
{ logError } = require 'app/scripts/debug/log-error'
{ Feature } = require 'app/scripts/debug/constants'
{
  TeamOnboardingPupPopover,
  TeamOnboardingPupTooltip,
} = require 'app/src/components/TeamOnboarding'

module.exports.unmountTeamOnboardingPupPopover = ->
  if @teamOnboardingPupPopoverDiv?
    ReactDOM.unmountComponentAtNode(@teamOnboardingPupPopoverDiv)

module.exports.unmountTeamOnboardingPupTooltip = ->
  if @teamOnboardingPupTooltipDiv?
    ReactDOM.unmountComponentAtNode(@teamOnboardingPupTooltipDiv)

module.exports.renderTeamOnboardingPupTooltip = ->
  if @model.viewState.get('showSidebar')
    return

  setTimeout(=>
    tooltip = React.createElement(TeamOnboardingPupTooltip, {
      onDismiss: => @unmountTeamOnboardingPupTooltip(),
    })

    @teamOnboardingPupTooltipDiv = document.createElement('div')
    $(@teamOnboardingPupTooltipDiv).insertAfter('.js-show-sidebar')
    ReactDOM.render(tooltip, @teamOnboardingPupTooltipDiv)
  , 1000)

module.exports.renderTeamOnboardingPupPopover = ->
  try
    org = @model.getOrganization()

    if !org?
      return

    if !@teamOnboardingPupPopoverDiv?
      targetDiv = @$("#team-onboarding-pup-popover-target")[0]

      if targetDiv?
        @teamOnboardingPupPopoverDiv = targetDiv
      else
        @$('.board-main-content').append("<div id='team-onboarding-pup-popover-target'></div>")
        @teamOnboardingPupPopoverDiv = @$("#team-onboarding-pup-popover-target")[0]

    boardId = @model.get('id')

    renderComponent(
      React.createElement(TeamOnboardingPupPopover, {
        orgId: org.id,
        boardId: boardId,
        onShowPowerUps: => @toggleDirectory(),
        onDismissed: => @renderTeamOnboardingPupTooltip(),
      }),
      @teamOnboardingPupPopoverDiv,
    )
  catch err
    logError({
      error: err,
      tags: {
        ownershipArea: 'trello-bizteam',
        feature: Feature.TeamOnboarding,
      }
    })
